import { useMemo } from "react";

const RESERVED_SUBDOMAINS = new Set(["www", "admin", "api", "app", "mail", "staging", "dev"]);

const BASE_DOMAIN = import.meta.env.VITE_APP_DOMAIN || "control-exchange.com";

/**
 * Detect if the current hostname is a storefront subdomain.
 * e.g., acme-corp.control-exchange.com → subdomain = "acme-corp"
 * Returns null for the bare domain, www, admin, localhost, etc.
 */
export function useSubdomain() {
  return useMemo(() => {
    const hostname = typeof window !== "undefined" ? window.location.hostname : "";

    // localhost / IP addresses → no subdomain
    if (!hostname || hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
      return { subdomain: null, isStorefrontSubdomain: false };
    }

    // Must end with the base domain
    if (!hostname.endsWith(`.${BASE_DOMAIN}`)) {
      return { subdomain: null, isStorefrontSubdomain: false };
    }

    // Extract subdomain by stripping the base domain
    const subdomain = hostname.slice(0, -(BASE_DOMAIN.length + 1));

    // Empty or reserved → not a storefront
    if (!subdomain || RESERVED_SUBDOMAINS.has(subdomain.toLowerCase())) {
      return { subdomain: null, isStorefrontSubdomain: false };
    }

    return { subdomain, isStorefrontSubdomain: true };
  }, []);
}

export { BASE_DOMAIN };
